import NextLink from "@/components/AppLink";

/** Internal dashboard routes (standalone app — no /app prefix). */
export function dashboardHref(href) {
  if (href == null || typeof href !== "string") return href;
  if (
    href.startsWith("http") ||
    href.startsWith("#") ||
    href.startsWith("mailto:") ||
    href.startsWith("tel:")
  ) {
    return href;
  }
  return href;
}

export default function DashboardLink({ href, ...props }) {
  return <NextLink href={dashboardHref(href)} {...props} />;
}
